import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { CardBillingComponent } from './card-billing/card-billing.component';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';
import {DataService} from "../../../shared/data.service";

declare let paypal: any;
@Component({
    selector: 'app-billing',
    templateUrl: './billing.component.html',
    styleUrls: ['./billing.component.scss'],
    standalone: false
})
export class BillingComponent implements AfterViewChecked {
  billingForm: any;
  transaction: any;
  addScript: boolean = false;
  paypalload = false;

  paypalconfig = {
    env: 'sandbox',
    client: {
      sandbox: 'AfLwhc2UmYN5ZDlvYP1PUWMPvJ76PoQ5m9IBmjkMUJ8pSe9xAuKXY_WwkFVfwPq3gPmeoEEv6Scu-FOe',
      // production: 'AfGW-J6bzgmG72HAUg9T_nEV3fBBuEcSXlXFcKNCmLdxHSWG2It_vYO6EYNlhIGSBkoptFAHS8DmRGZO'
    },
    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            {amount: {total: this.count * this.subscriptionExtraPrice, currency: 'EUR'}}
          ]
        }
      });
    },
    onError:  (data, actions) => {
    },
    onAuthorize: (data, actions) => {
      const response = actions.payment.execute().then(function(payment) {
        return payment;
      });
      this.transaction = { data, response,
        Type: 1};
      return this.paypalBill();
    },
    style: {
      color: 'black',
      shape: 'rect',
      label: 'checkout',
      tagline: false,
      layout: 'vertical'
  },
  funding:
    {
        disallowed: [ ]
    },
  };
  count: any;
  user: User;
  userData: User;
  subscriptionExtraPrice: number = 450;

  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {
        // this.paypalconfig.funding = {disallowed: [ paypal.FUNDING.CREDIT ]};
        paypal.Button.render(this.paypalconfig, '#paypal-checkout-btn');
        this.paypalload = true;
      });
    }
  }
  constructor(private utils: UtilsService, public dialog: MatDialog,
              private dataService: DataService,
              public router: Router, private route: ActivatedRoute, private authService: AuthService) {
              this.user = this.authService.getUserData();
              this.route.params
                .subscribe(
                  (params: Params) => {
                    this.count = params.count;
                  });
              }

  ngOnInit(): void {
    this.utils.screenTitle.emit({firstTitle: 'Sponsoring', firstRoute: '/sponsoring',
    secondTitle: 'Billing', secondRoute: '/billing',
    });
    this.billingForm = new FormGroup({
      sponsorCounts: new FormControl({ value: this.count, disabled: true }),
      totalFees: new FormControl({ value: this.count * this.subscriptionExtraPrice , disabled: true }),
      totalFeesDiscount: new FormControl({ value: this.count * this.subscriptionExtraPrice, disabled: true }),
    });
    this.dataService.get('user/RetrieveUser/' + this.user.id).then((data) => {
      if (data.statusCode === 200) {
        this.userData = data.data;
        if (this.userData.promotionCodeCount > 199) {
          this.subscriptionExtraPrice = this.utils.plans.distributor.titanium.subscriptionExtraPrice;
        } else if (this.userData.promotionCodeCount > 99) {
          this.subscriptionExtraPrice = this.utils.plans.distributor.diamond.subscriptionExtraPrice;
        } else if (this.userData.promotionCodeCount > 49) {
          this.subscriptionExtraPrice = this.utils.plans.distributor.platinum.subscriptionExtraPrice;
        } else if (this.userData.promotionCodeCount > 19) {
          this.subscriptionExtraPrice = this.utils.plans.distributor.gold.subscriptionExtraPrice;
        } else if (this.userData.promotionCodeCount > 9) {
          this.subscriptionExtraPrice = this.utils.plans.distributor.silver.subscriptionExtraPrice;
        } else if (this.userData.promotionCodeCount > 4) {
          this.subscriptionExtraPrice = this.utils.plans.distributor.bronze.subscriptionExtraPrice;
        } else{
          this.subscriptionExtraPrice = 450;
        }
        this.billingForm.get('totalFees').setValue(this.count * this.subscriptionExtraPrice );
        this.billingForm.get('totalFeesDiscount').setValue(this.count * this.subscriptionExtraPrice );
      }
    });
  }

  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      const scripttagelement = document.createElement('script');
      scripttagelement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagelement.onload = resolve;
      document.body.appendChild(scripttagelement);
    });
  }

  buyWithCard() {
    const dialogRef = this.dialog.open(CardBillingComponent,
      {disableClose: true, width: '400px', data: {totalAmount: this.billingForm.get('totalFeesDiscount').value, codesCount: this.count}});
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
        this.router.navigate(['/sponsoring'], );
      }
    });
  }

  paypalBill(){
    const payload = {
      Amount: (parseInt(this.count) * this.subscriptionExtraPrice),
      Currency: 'EUR',
      Description: 'Buy ' + this.count + ' sponsors',
      Token: this.transaction.data.paymentID,
      Count: parseInt(this.count),
      Type: 1
    };
    this.dataService.post('billing/BillingGateway', payload).then((data) => {
      if (data.statusCode === 200) {
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Payment done successfully',
            type: 'Success',
            message: 'Your payment has been done successfully, thank you!',
            buttonText: 'Ok'
          }
        });
        this.router.navigate(['/sponsoring'], );

      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'something went wrong, please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }


}
